// ─────────────────────────────────────────────
// KLOTHIQ — Sale Zod Schemas
// ─────────────────────────────────────────────

import { z } from 'zod';
import { SaleStatus } from '@klothiq/domain';
import { moneySchema, moneyOrZeroSchema, quantitySchema, dateSchema } from './common.schema';

export const saleItemFormSchema = z.object({
  variant_id: z.string().uuid('Select a product variant'),
  quantity: quantitySchema,
  unit_price: moneySchema,
  discount: moneyOrZeroSchema,
});

export const saleFormSchema = z.object({
  customer_id: z.string().uuid().nullable().optional(),
  sold_by: z.string().uuid().nullable().optional(),
  sale_date: dateSchema,
  sale_status: z.nativeEnum(SaleStatus).default(SaleStatus.DRAFT),
  delivery_charge: moneyOrZeroSchema,
  notes: z.string().max(1000).nullable().optional(),
  items: z.array(saleItemFormSchema).min(1, 'At least one item is required'),
});

export const changeSaleStatusSchema = z.object({
  sale_id: z.string().uuid(),
  new_status: z.nativeEnum(SaleStatus),
});

export type SaleItemFormValues = z.infer<typeof saleItemFormSchema>;
export type SaleFormValues = z.infer<typeof saleFormSchema>;
export type ChangeSaleStatusValues = z.infer<typeof changeSaleStatusSchema>;
